import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';

const DiscountSuggestion = ({ cartValue, onApply }) => {
  const [suggestion, setSuggestion] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getSuggestion = async () => {
    if (!cartValue || cartValue <= 0) {
      setError('Cart value is required');
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      // Get auth token
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      
      // Get API base URL from config
      const apiBaseUrl = process.env.REACT_APP_API_URL || 
        (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
          ? 'http://localhost:3003' 
          : 'https://cartresq-yiq2.onrender.com');
      
      // Call backend API instead of n8n
      const response = await fetch(`${apiBaseUrl}/api/ai/discount-suggestion`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          cartValue: parseFloat(cartValue)
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // Validate response structure
      if (data && typeof data.discount === 'number') {
        setSuggestion(data);
      } else {
        throw new Error('Invalid response format - missing discount field');
      }
    } catch (err) {
      console.error('AI suggestion error:', err);
      setError(err.message || 'AI suggestion unavailable');
    } finally {
      setLoading(false);
    }
  };

  if (suggestion) {
    return (
      <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-md">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1">
            <p className="text-sm font-medium text-blue-900">
              Suggested Discount: <strong>{suggestion.discount}%</strong>
            </p>
            {suggestion.reason && (
              <p className="text-xs text-blue-700 mt-1">
                {suggestion.reason}
              </p>
            )}
            {suggestion.analyticsUsed && (
              <p className="text-xs text-blue-600 mt-1 italic flex items-center gap-1">
                <span>✓</span>
                <span>Based on your store's analytics data</span>
              </p>
            )}
          </div>
          {onApply && (
            <button
              onClick={() => onApply(suggestion.discount)}
              className="px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 whitespace-nowrap"
            >
              Apply
            </button>
          )}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-xs text-red-600 mt-2">
        {error}
      </div>
    );
  }

  return (
    <button
      onClick={getSuggestion}
      className="text-xs text-blue-600 flex items-center gap-1 mt-2 hover:underline"
      disabled={loading || !cartValue}
      type="button"
    >
      <Sparkles className="w-3 h-3" />
      {loading ? 'Thinking...' : 'Get AI suggestion'}
    </button>
  );
};

export default DiscountSuggestion;

